export default __webpack_public_path__ + "static/media/logo_Sixtema_Bianco.9b9f00a8.png";